"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _Item = _interopRequireDefault(require("./Item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MainNavigation = function MainNavigation(_ref) {
  var className = _ref.className,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["className", "children"]);

  return /*#__PURE__*/_react.default.createElement(NavigationBar, _extends({}, otherProps, {
    className: className
  }), children);
};

var Line = _styledComponents.default.div.withConfig({
  displayName: "Line"
})(["height:0.1rem;width:100%;background-color:#f0f1f3;"]);

var Title = _styledComponents.default.h1.withConfig({
  displayName: "Title"
})(["text-transform:uppercase;font-size:1.2rem;margin-left:2.5rem;color:", ";margin-bottom:1rem;margin-top:1.5rem;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.ui.disabled;
});

var NavigationBar = _styledComponents.default.nav.withConfig({
  displayName: "NavigationBar"
})(["font-family:", ";height:100vh;width:25rem;z-index:10;background-color:white;display:flex;flex-direction:column;position:fixed;border-right:1px solid #f0f1f3;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
});

var Terms = _styledComponents.default.a.withConfig({
  displayName: "Terms"
})(["font-size:1.4rem;margin:2rem 0 1rem 2.5rem;text-decoration:none;font-weight:500;color:#525252;&:hover{cursor:pointer;color:", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.brand.dark;
});

var Copy = _styledComponents.default.p.withConfig({
  displayName: "Copy"
})(["font-size:1.4rem;margin-left:2.5rem;color:", ";line-height:120%;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.ui.disabled;
});

var SignOutContainer = _styledComponents.default.div.withConfig({
  displayName: "SignOutContainer"
})(["margin-top:auto;"]);

MainNavigation.Title = Title;
MainNavigation.Title.displayName = 'MainNavigation.Title';
MainNavigation.Line = Line;
MainNavigation.Line.displayName = 'MainNavigation.Line';
MainNavigation.Item = _Item.default;
MainNavigation.Item.displayName = 'MainNavigation.Item';
MainNavigation.Terms = Terms;
MainNavigation.Terms.displayName = 'MainNavigation.Terms';
MainNavigation.Copy = Copy;
MainNavigation.Copy.displayName = 'MainNavigation.Copy';
MainNavigation.SignOutContainer = SignOutContainer;
MainNavigation.Copy.SignOutContainer = 'MainNavigation.SignOutContainer';
MainNavigation.defaultProps = {
  otherProps: {}
};
MainNavigation.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,
  children: _propTypes.node
};
var _default = MainNavigation;
exports.default = _default;